import { render, staticRenderFns } from "./consulting_view.vue?vue&type=template&id=42ca3638&scoped=true&"
import script from "./consulting_view.vue?vue&type=script&lang=ts&"
export * from "./consulting_view.vue?vue&type=script&lang=ts&"
import style0 from "./consulting_view.vue?vue&type=style&index=0&id=42ca3638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca3638",
  null
  
)

export default component.exports